import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import ComponentContainer from './atoms/ComponentContainer';
import type { CaptionedImage as CaptionedImageProps } from '../types/app';


export const CaptionedImage = (props: CaptionedImageProps) => {
    const image = props.image ? getImage(props.image) : null;
    if(!image)
        return null
    return (
        <ComponentContainer contentful_id={props.contentful_id}>
            <Container maxWidth={props?.maxWidth || 'sm'} data-sb-field-path = "maxWidth">
                <Box data-sb-field-path = "image">
                    <GatsbyImage 
                        image               = {image} 
                        alt                 = {props.image.title} 
                    />
                </Box>
                {
                    props?.caption &&
                    <Box data-sb-field-path = "caption" sx={{p:1, background:theme => theme.palette.divider}}>
                        <Typography variant="caption">
                            Figure: {props.caption}
                        </Typography>
                    </Box>
                }
            </Container>
        </ComponentContainer>
    )
};

export default CaptionedImage;
